var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-394 -95)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M406.567 95.395l3.053 7.577 7.816.704c.542.05.762.759.35 1.132l-5.927 5.386 1.776 8.012c.123.557-.452.995-.918.699l-6.716-4.248-6.717 4.248c-.467.294-1.04-.144-.918-.7l1.777-8.011-5.93-5.387c-.411-.374-.192-1.083.352-1.132l7.815-.704 3.053-7.576c.212-.527.923-.527 1.134 0zm-.17 3.482c-.148-.37-.646-.37-.794 0l-2.137 5.303-5.47.492c-.381.035-.535.531-.247.793l4.151 3.77-1.244 5.61c-.086.388.316.694.643.488L406 112.36l4.701 2.973c.326.207.729-.1.643-.489l-1.244-5.608 4.15-3.77c.288-.262.133-.758-.246-.793l-5.47-.493-2.138-5.303zm-.397 2.225l1.695 4.208 4.497.405-2.898 2.632-.515.469 1 4.514-3.137-1.984-.641-.406-3.78 2.39.85-3.835.151-.68-3.414-3.101 3.766-.34.73-.065 1.696-4.207z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }